import type { ErrorMessages } from '@repo/types/messages/errors';

import { ErrorCodes } from '#errorCodes';

import { baseErrorMessages } from './baseErrorMessages';

export const fsErrorMessages: ErrorMessages = {
  ...baseErrorMessages,
  403: {
    title: 'Brak uprawnień',
    detail: 'Nie posiadasz uprawnień do tego zasobu.',
  },
  404: {
    title: 'Nie znaleziono zasobu',
    detail: 'Żądany zasób nie istnieje lub został usunięty.',
  },
  [ErrorCodes.DB.DB_ERR]: {
    title: 'Nie znaleziono zasobu',
    detail: 'Żądany zasób nie istnieje lub został usunięty.',
  },
  [ErrorCodes.FORBIDDEN.FS.PERMISSION.NO_READ]: {
    title: 'Brak uprawnień',
    detail: 'Nie posiadasz uprawnień do odczytu tego zasobu.',
  },
  [ErrorCodes.FORBIDDEN.FS.PERMISSION.NO_EDIT]: {
    title: 'Brak uprawnień',
    detail: 'Nie posiadasz uprawnień do edycji tego zasobu.',
  },
  [ErrorCodes.FORBIDDEN.FS.PERMISSION.NO_WRITE]: {
    title: 'Brak uprawnień',
    detail: 'Nie posiadasz uprawnień do zapisu w tym zasobie.',
  },
  [ErrorCodes.FORBIDDEN.FS.PERMISSION.NO_MANIP_INTERNAL]: {
    title: 'Operacja niedozwolona',
    detail: 'Ta operacja nie jest dozwolona dla tego typu zasobu.',
  },
};
